import type { StylesConfig } from "react-select";

/** Shared react-select overrides; field size is controlled in AuthFlow.css. */
export function getSignupProfileSelectStyles<Option, IsMulti extends boolean = false>(
  invalid = false,
): StylesConfig<Option, IsMulti> {
  return {
    control: (base, state) => ({
      ...base,
      borderColor: invalid
        ? "#dc3545"
        : state.isFocused
          ? "#3a97a4"
          : "rgba(148, 163, 184, 0.55)",
      boxShadow: invalid
        ? "0 0 0 0.2rem rgba(220, 53, 69, 0.25)"
        : state.isFocused
          ? "0 0 0 0.2rem rgba(58, 151, 164, 0.45)"
          : "none",
      "&:hover": {
        borderColor: invalid
          ? "#dc3545"
          : state.isFocused
            ? "#3a97a4"
            : "rgba(58, 151, 164, 0.5)",
      },
      minHeight: "var(--auth-signup-field-height, 2.625rem)",
      borderRadius: "0.375rem",
      fontSize: "0.9375rem",
      cursor: "pointer",
    }),
    valueContainer: (base) => ({
      ...base,
      padding: "0 0.75rem",
      height: "calc(var(--auth-signup-field-height, 2.625rem) - 2px)",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: "calc(var(--auth-signup-field-height, 2.625rem) - 2px)",
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: "0.9375rem",
      color: "#94a3b8",
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: "0.9375rem",
      color: "#0f172a",
    }),
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
      fontSize: "0.9375rem",
    }),
    menuPortal: (base) => ({ ...base, zIndex: 10050 }),
  };
}
